import React, { PropsWithChildren, useContext, useMemo } from "react";

type ContextValue = {
  workspaceId: string;
  workspacePermissions: WorkspacePermissions;
};

type WorkspacePermissions = {
  write: boolean;
  read: boolean;
};

const CTX = React.createContext<ContextValue | null>(null);

export const useWorkspaceId = () => {
  const val = useContext(CTX);
  if (val === null) {
    throw new Error("useWorkspaceId must be used within a WorkspaceIdProvider");
  }
  return val.workspaceId;
};
export const useWorkspacePermissions = () => {
  const val = useContext(CTX);
  if (val === null) {
    throw new Error(
      "useWorkspacePermissions must be used within a WorkspaceIdProvider"
    );
  }
  return val.workspacePermissions;
};

export function WorkspaceWritable(props: { children: React.ReactNode }) {
  const { write } = useWorkspacePermissions();

  if (write) {
    return props.children;
  }
  return null;
}

export const WorkspaceIdProvider = (
  props: PropsWithChildren<{
    workspaceId: string;
    workspacePermissions: WorkspacePermissions;
  }>
) => {
  const value = useMemo(() => {
    return {
      workspaceId: props.workspaceId,
      workspacePermissions: props.workspacePermissions,
    };
  }, [props.workspaceId, props.workspacePermissions]);
  return <CTX.Provider value={value}>{props.children}</CTX.Provider>;
};
